import React, { useEffect, useState } from "react";
import { Button, Dialog, Drawer, Tag } from "@stonelog/stonelog-design-system";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { deleteTrackingDelivery, getTrackingDeliveries, resetDeleteDeliveryStates, trackingDeliveriesSelector } from "../../../../../../../features/senninha/trackingDeliveriesSlice";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeAllFirstLetters } from "../../../../../../../consumingApi/services/helper";
import DetailsDeliveryContentTracking from "./DetailsDeliveryContentTracking";
import { hubsSelector } from "../../../../../../../features/senninha/hubsSlice";
import warning from "@assets/icons/Warning.svg";
import { oplFromTo } from "../../../../Map/components/Drawers/util";

import * as S from "./styles";


const DetailsDeliveryContent = ({ open, onClose, data }) => {
    const [openCloseModal, setOpenCloseModal] = useState(false);

    const {
        statusDeleteDelivery,
    } = useSelector(trackingDeliveriesSelector)

    const {
        selectedHubInfos
    } = useSelector(hubsSelector);

    const dispatch = useDispatch()

    const countItems = (items) => {
        const counts = items.reduce((data, item) => {
            data[item] = (data[item] || 0) + 1;
            return data;
        }, {});

        return Object.keys(counts).map((key) => ({
            name: key,
            amount: counts[key]
        }));
    }

    const getServicesFormatted = (services) => {
        const aux = services.map(({ servico }) => servico)
        if (!aux) return ''

        return aux.length === 1 ?
            capitalizeAllFirstLetters(aux[0])
            : countItems(aux).map(({ name, amount }) => 
                `${capitalizeAllFirstLetters(name)} (${amount})`
              ).toString().replace(',', ', ')
    }

    const getOSsFormatted = (oss) => {
        const aux = oss.map(({ id_os }) => id_os)
        if (!aux) return ''

        return aux.length === 1 ?
            aux[0]
            : aux.toString().replaceAll(',', ', ')
    }

    const handleDeleteDelivery = () => {
        dispatch(deleteTrackingDelivery({
            reference_key: data.reference_key,
            provider: selectedHubInfos.children
        }))
    }

    useEffect(() => {
        if (statusDeleteDelivery === 'fulfilled') {
            onClose()
            dispatch(resetDeleteDeliveryStates())
            dispatch(getTrackingDeliveries(selectedHubInfos.children))
            setOpenCloseModal(false)
        }
    }, [statusDeleteDelivery])

    return (
        <>
            <Dialog.Root
                open={openCloseModal}
                onCancel={() => setOpenCloseModal(false)}
            >
                <Dialog.Header title="Atenção" />

                <Dialog.ContentHeader
                    ilustration={<img src={warning} />}
                    description={`Ao cancelar, todos os atendimentos inseridos no lote ${data?.num_pedido || ''} serão cancelados. Tem certeza de que deseja continuar?`}
                />

                <Dialog.Footer>
                    <Button onClick={() => setOpenCloseModal(false)}>Voltar</Button>
                    <Button
                        type="negative"
                        onClick={handleDeleteDelivery}
                        loading={statusDeleteDelivery === 'pending'}
                    >
                        {statusDeleteDelivery !== 'pending' && (<GingaIcon name='round-error' color="#FFFFFF" size={20} />)}
                        Cancelar delivery
                    </Button>
                </Dialog.Footer>
            </Dialog.Root>
            <Drawer.Body>
                {data &&
                    <S.AllDeliveryDrawerContent>
                        {(open && data.tracking_code) && (
                            <DetailsDeliveryContentTracking isOpen={open} trackingCode={data.tracking_code} />
                        )}
                        <S.AllBodyContainer>
                            <S.BodyTopContainer>
                                <S.BodyTopContent>
                                    <p>
                                        Status
                                    </p>
                                    <span>
                                        <Tag
                                            text={capitalizeAllFirstLetters(data.status.mensagem)}
                                            type={data.status.tipo}
                                        />
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Previsão de entrega
                                    </p>
                                    <span>
                                        {data.previsao_entrega}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Cliente
                                    </p>
                                    <span>
                                        {data.cliente}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Contato do cliente
                                    </p>
                                    <span>
                                        {data.contato}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Endereço
                                    </p>
                                    <span>
                                        {data.endereco}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Contratante
                                    </p>
                                    <span>
                                        {data.contratante}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Stonecode
                                    </p>
                                    <span>
                                        {data.id_atendimento}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Grupo de serviço
                                    </p>
                                    <span>
                                        {getServicesFormatted(data.oss)}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Nº da OS
                                    </p>
                                    <span>
                                        {getOSsFormatted(data.oss)}
                                    </span>
                                </S.BodyTopContent>
                                <S.BodyTopContent>
                                    <p>
                                        Operador logístico
                                    </p>
                                    <span>
                                        {capitalizeAllFirstLetters(oplFromTo(data.operador_logistico))}
                                    </span>
                                </S.BodyTopContent>
                                {data?.motorista_responsavel && (
                                    <S.BodyTopContent>
                                        <p>
                                        Motorista
                                        </p>
                                        <span>
                                            {data.motorista_responsavel}
                                        </span>
                                    </S.BodyTopContent>
                                )}
                                {data?.motorista_contato && (
                                    <S.BodyTopContent>
                                        <p>
                                        Contato do motorista
                                        </p>
                                        <span>
                                            {data.motorista_contato}
                                        </span>
                                    </S.BodyTopContent>
                                )}
                                <S.BodyTopContent>
                                    <p>
                                        Código Stone Entrega
                                    </p>
                                    <span>
                                        {data.tracking_code}
                                    </span>
                                </S.BodyTopContent>
                            </S.BodyTopContainer>
                        </S.AllBodyContainer>
                    </S.AllDeliveryDrawerContent>
                }
            </Drawer.Body>
    
            {data && data?.status?.cancelavel && !data?.motorista_responsavel &&
                <Drawer.Footer>
                    <Button
                        width="100%"
                        type="negative"
                        size="medium"
                        onClick={()=> setOpenCloseModal(true)}
                        loading={statusDeleteDelivery === 'pending'}
                    >
                        {statusDeleteDelivery !== 'pending' && (<GingaIcon name='round-error' color="#FFFFFF" size={20} />)}
                        Cancelar delivery
                    </Button>
                </Drawer.Footer>
            }
        </>
    )
}

export default DetailsDeliveryContent;
